import { CasErrorDisplay, CasLoaderWithBackdrop } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';

import { useReqIdParam } from './useReqIdParam';

import PublicUploadFileForm from './PublicUploadFileForm';

export default function PublicUploadFilesContainer() {
  const reqId = useReqIdParam();

  const { data, isFetching, error, isError, refetch } = useRetrieve({
    url: 'Public/Uploads',
    params: { reqId },
    enabled: !!reqId,
  });

  if (!reqId) return <CasErrorDisplay message="Invalid Request" />;
  if (isFetching) return <CasLoaderWithBackdrop />;
  if (isError) return <CasErrorDisplay message={error?.message} />;

  return <PublicUploadFileForm onSaved={refetch} row={data} />;
}
